<template>
  <div>
    <div
      v-for="item in visibleItems"
      :key="item.id"
      class="imagelist-item"
    >
      <router-link :to="{ name: item.linkTo, params: { id: item.id, parent: item.parent  }}">
        <img :src="item.image" />
      </router-link>
      <hr>
      <router-link :to="{ name: item.linkTo, params: { id: item.id, parent: item.parent  }}">
        <div  class="arrow-right"/>{{item.linkText}}
      </router-link>
    </div>
  </div>
</template>

<script>
import Utils from '@/js/utils.js'
export default {
  name: 'ImageList',
  props: {
    items: {
      type: Array
    }
  },
  methods:{
  	analyse_item: function(item){
  		Utils.analyse_item(item);
  	
  	}
  
  },
  computed: {
    visibleItems: function() {
      return this.items.filter(item => item.visible == 1);
    }
  }
}
</script>

<style scoped>
.imagelist-item {
  padding: 1rem 2rem 1rem 0;
  float: left;
}
img {
  display: block;
  width: auto;
  margin: auto;
  height: 100px;
}
hr {
  margin-top: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/elements/ImageList.vue